<div class="dialog-container">
    <!-- Scrollable Content Area -->
    <div class="dialog-content">
        <!-- Dialog Header -->
        <div class="dialog-header d-flex justify-content-between align-items-center mb-4">
            <h4 class="dialog-title mb-0">
                <i class="fas fa-clock me-2"></i>Waiting for Attendance - {{ meetingTitle }}
            </h4>
            <button type="button" class="close-btn" (click)="minimizeDialog()" aria-label="Minimize dialog" title="Minimize">
                <i class="bi bi-dash-lg"></i>
            </button>
        </div>

        <!-- Attendance Summary -->
        <div class="attendance-summary mb-4">
            <div class="row">
                <div class="col-md-4">
                    <div class="summary-card">
                        <div class="summary-label">Total Invited</div>
                        <div class="summary-value">{{ invitedMembers.length }}</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="summary-card success">
                        <div class="summary-label">Joined</div>
                        <div class="summary-value">{{ getJoinedCount() }}</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="summary-card warning">
                        <div class="summary-label">Not Joined</div>
                        <div class="summary-value">{{ getNotJoinedCount() }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Invited Members List -->
        <div class="attending-section mb-4">
            <h5 class="section-title fw-bold mb-3">
                <i class="fas fa-users me-2"></i>Invited Members
            </h5>
            
            <div class="attendees-list">
                <div *ngIf="invitedMembers.length === 0" class="text-muted text-center py-4">
                    No members invited
                </div>
                <div *ngFor="let member of getSortedMembers()" class="attendee-item" [class.joined]="hasMemberJoined(member)">
                    <div class="attendee-info">
                        <i *ngIf="!hasMemberJoined(member)" class="fas fa-user-circle text-secondary me-2"></i>
                        <i *ngIf="hasMemberJoined(member)" class="fas fa-check-circle text-success me-2"></i>
                        <div class="attendee-details">
                            <div class="attendee-name">{{ member.name || member.userName || member.email || 'User' }}</div>
                            <div class="attendee-role text-muted" *ngIf="member.role">{{ member.role }}</div>
                        </div>
                    </div>
                    <div class="attendee-status">
                        <span *ngIf="hasMemberJoined(member)" class="badge bg-success">
                            <i class="fas fa-check me-1"></i>Joined
                        </span>
                        <span *ngIf="!hasMemberJoined(member)" class="badge bg-secondary">
                            <i class="fas fa-clock me-1"></i>Waiting
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fixed Action Buttons Bar -->
    <div class="dialog-footer d-flex justify-content-between align-items-center">
        <!-- Left side: Leave Meeting button for all members except host (only if they have joined) -->
        <div>
            <button 
                *ngIf="!isHoster() && hasCurrentUserJoined()" 
                type="button" 
                class="btn btn-outline-danger" 
                (click)="leaveMeeting()">
                <i class="fas fa-sign-out me-2"></i>Leave Meeting
            </button>
        </div>
        
        <!-- Right side: Close, Attend (for all members except host), End Meeting (for hoster), and Start Meeting buttons -->
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-secondary" (click)="onCancel()">
                <i class="fas fa-times me-2"></i>Close
            </button>
            
            <!-- Attend button for all invited members except host (only if they haven't joined yet) -->
            <button 
                *ngIf="!isHoster() && !hasCurrentUserJoined()" 
                type="button" 
                class="btn btn-success" 
                (click)="attendMeeting()">
                <i class="fas fa-check me-2"></i>Attend
            </button>
            
            <!-- End Meeting button for Secretary -->
            <button 
                *ngIf="isHoster()" 
                type="button" 
                class="btn btn-danger me-2" 
                (click)="endMeeting()">
                <i class="fas fa-stop me-2"></i>End Meeting
            </button>
            
            <!-- Start Meeting button for Secretary only -->
            <button 
                *ngIf="isHoster()" 
                type="button" 
                class="btn btn-primary" 
                (click)="beginMeeting()">
                <i class="fas fa-play me-2"></i>Start Meeting
            </button>
        </div>
    </div>
</div>

